module.exports = __webpack_public_path__ + "img/42.4.NH3-N.776b7160.png";